import {IRule} from "./model";

export const listRFMContractorType = [
    {
        code: 'APT',
        label: 'APT'
    },
    {
        code: 'RA',
        label: 'RA'
    },
    {
        code: 'CA',
        label: 'CA'
    },
    {
        code: 'Other',
        label: 'Other'
    }
];

export const DMS_ENTITY = {
    "code": "RFM_STATE_MANAGEMENT",
    "data": {
        "id": "0",
        "type": "BOOK",
        "salesChannel": "CODE01",
        "rentalType": "RETAIL",
        "creationDatetime": "2022-07-22T09:19:42.667+00:00",
        "updateDatetime": "2022-07-22T09:19:42.667+00:00",
        "cancellationDatetime": null,
        "pickupDate": "2022-06-01",
        "dropoffDate": "2022-06-05",
        "totalRentalDays": 4,
        "note": "",
        "discountCode": "",
        "status": 15,
        "subStatus": 1,
        "mileageIncluded": "100km",
        "keyless": false,
        "productFirstBooking": true,
        "unsatisfiedPendingRuleStopSale": false,
        "externalNumber": null,
        "renewal": "FALSE",
        "idSmProduct": null,
        "tenant": null,
        "dealer": null,
        "creationOperatorId": null,
        "updateOperatorId": null,
        "creditType": null,
        "delivery": null,
        "deliveryAdress": null,
        "deliveryPostalCode": null,
        "deliveryCity": null,
        "deliveryState": null,
        "collection": null,
        "collectionAdress": null,
        "collectionPostalCode": null,
        "collectionCity": null,
        "collectionState": null,
        "specialConditionAccepted": null,
        "flightNumber": null,
        "replacePlaceNumber": null,
        "rentalAgreement": null,
        "paymentProvider": null,
        "paymentStatus": null,
        "totalToBePaid": null,
        "blackList": null,
        "vip": null,
        "expiredAt": null,
        "userProcessing": null,
        "dateProcessing": null,
        "blackListDescription": "",
        "sourceCountry": "",
        "subScriptionNumber": "",
        "cig": "",
        "cup": "",
        "orderCode": "",
        "carGroupModels": "",
        "category": "",
        "secondCreditCardRequired": false
    }
}

export const DASHBOARD_CONTRACT_OF_SUBCONCESSION_DATA_MOCK = [
    {
        "description": "Ufficio",
        "unitYear": 123,
        "totalYear": 123,
        "january": 3,
        "ninJanuary": 3,
        "february": 3,
        "ninFebruary": 0,
        "ninMarch": 33,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Area Comune",
        "unitYear": 12,
        "totalYear": 12,
        "january": 13,
        "ninJanuary": 13,
        "february": 13,
        "ninFebruary": 130,
        "ninMarch": 3123,
        "ninApril": 32131,
        "ninMay": 31231,
        "ninJune": 312313,
        "ninJuly": 31231,
        "ninAugust": 32131,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0

    },
    {
        "description": "Cabin",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        "description": "Magazzino",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        "description": "Area Comune 2",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        "description": "Area DryCleaning",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        "description": "Posti Auto Adiacenti",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Auto Remoti",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Auto Elettrificati",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Auto Carsharing",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Dipendenti",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Area Parcheggio Esterna",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Servizio Cabin",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Utenze Comuni",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Consumi Elettrici",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Pulizie Ufficio",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Pulizie Parcheggio",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Manutenzione",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Linee Dati/Fonia",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Contributo Pubblicitario",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Cartellone Pubblicitario",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Shuttle",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Vigilanza",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    }];

export const DASHBOARD_SHORT_TERM_DATA_MOCK = [
    {
        "description": "Minimo Annuo Garantito",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {

        "description": "Fatturato",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0

    },
    {
        "description": "Iva",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {

        "description": "Base Imponibile",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0

    },
    {

        "description": "Royalties (I)",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0

    },
    {

        "description": "Rentals",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0

    }
    ];

export const DASHBOARD_CAR_SHARING_DATA_MOCK = [
    {
        "description": "Minimo Annuo Garantito",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Royalties",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Rentals",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    }
];

export const DASHBOARD_CONTRACTOR_EMPTY_LIST = [
    {
        "description": "Ufficio",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Area Comune",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        "description": "Cabin",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Magazzino",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Area Comune 2",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Area DryCleaning",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Auto Adiacenti",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Auto Remoti",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Auto Elettrificati",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Auto Carsharing",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Posti Dipendenti",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Area Parcheggio Esterna",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Servizio Cabin",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Utenze Comuni",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Consumi Elettrici",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Pulizie Ufficio",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Pulizie Parcheggio",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Manutenzione",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Linee Dati/Fonia",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Contributo Pubblicitario",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Cartellone Pubblicitario",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Shuttle",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    },
    {
        
        "description": "Vigilanza",
        "unitYear": 0,
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
        "sm_qty": 0
    }];

export const DASHBOARD_SHORT_TERMS_EMPTY_LIST = [
    {
        "description": "Minimo Annuo Garantito",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    },
    {
        "description": "Fatturato",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,

    },
    {
        "description": "Iva",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    },
    {
        "description": "Base Imponibile",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,

    },
    {
        "description": "Royalties (I)",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,

    },
    {
        
        "description": "Rentals",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,

    },
    {
        "description": "Adjustment 1",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    },
    {
        "description": "Adjustment 2",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    }
];

export const DASHBOARD_CAR_SHARING_EMPTY_LIST = [
    {
        "description": "Minimo Annuo Garantito",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    },
    {
        "description": "Royalties",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    },
    {
        "description": "Rentals",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    },
    {
        "description": "Adjustment 1",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    },
    {
        "description": "Adjustment 2",
        "note1": "",
        "note2": "",
        "totalYear": 0,
        "january": 0,
        "ninJanuary": 0,
        "february": 0,
        "ninFebruary": 0,
        "ninMarch": 0,
        "ninApril": 0,
        "ninMay": 0,
        "ninJune": 0,
        "ninJuly": 0,
        "ninAugust": 0,
        "ninSeptember": 0,
        "ninOctober": 0,
        "ninNovember": 0,
        "ninDecember": 0,
        "march": 0,
        "april": 0,
        "may": 0,
        "july": 0,
        "december": 0,
        "october": 0,
        "total": 0,
        "august": 0,
        "november": 0,
        "june": 0,
        "september": 0,
    }

];

export interface ICurrentYearDashboard {
    description: string,
    unitYear?: number,
    totalYear?: number,
    sm_qty?: number,
    january: number,
    ninJanuary: number,
    february: number,
    ninFebruary: number,
    ninMarch: number,
    ninApril: number,
    ninMay: number,
    ninJune: number,
    ninJuly: number,
    ninAugust: number,
    ninSeptember: number,
    ninOctober: number,
    ninNovember: number,
    ninDecember: number,
    march: number,
    april: number,
    may: number,
    july: number,
    december: number,
    october: number,
    total: number,
    august: number,
    november: number,
    june: number,
    september: number
}

export const ROYALTY_EMPTY_OBJ = {
    id: 0,
    royaltiesEmail: "",
    royaltiesRate: "",
    contractorType: "",
    rateable: "",
    contractorIdentificationCode: "",
    contractorName: "",
    voices: [],
    splitOffs: []
}

